import { ComponentType, type IFormilySchema } from '../types';
import { findFormComponent } from './findFormComponent';
import { JsonFieldType } from '../../types';

export const getSchemaFields = <T>(
  childSchema: IFormilySchema | undefined,
  predicate: (fieldDef: any) => boolean,
  mapper: (key: string, fieldDef: any) => T
): T[] => {
  const formComponent = findFormComponent(childSchema);

  if (!formComponent?.properties) return [];

  return Object.entries(formComponent.properties)
    .filter(([, fieldDef]) => predicate(fieldDef))
    .map(([key, fieldDef]) => mapper(key, fieldDef));
};

const SKIP_COMPONENTS = [
  ComponentType.FormTitle,
  ComponentType.FormText,
  ComponentType.FormLink,
];

function collectFields<T>(
  properties: Record<string, any>,
  predicate: (fieldDef: any) => boolean,
  mapper: (key: string, fieldDef: any) => T,
  results: T[]
): void {
  for (const [key, fieldDef] of Object.entries(properties)) {
    if (SKIP_COMPONENTS.includes(fieldDef['x-component'])) continue;

    if (fieldDef.properties && fieldDef.type === JsonFieldType.VOID) {
      collectFields(fieldDef.properties, predicate, mapper, results);
      continue;
    }

    if (predicate(fieldDef)) {
      results.push(mapper(key, fieldDef));
    }
  }
}

export const getSchemaFieldsV2 = <T>(
  schema: IFormilySchema | undefined,
  predicate: (fieldDef: any) => boolean,
  mapper: (key: string, fieldDef: any) => T
): T[] => {
  const formComponent = findFormComponent(schema);

  if (!formComponent?.properties) return [];
  const results: T[] = [];
  collectFields(formComponent.properties, predicate, mapper, results);
  return results;
};
